// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-office-tsx": () => import("./../../../src/pages/office.tsx" /* webpackChunkName: "component---src-pages-office-tsx" */),
  "component---src-pages-valis-loizides-tsx": () => import("./../../../src/pages/valis-loizides.tsx" /* webpackChunkName: "component---src-pages-valis-loizides-tsx" */),
  "component---src-pages-work-tsx": () => import("./../../../src/pages/work.tsx" /* webpackChunkName: "component---src-pages-work-tsx" */),
  "component---src-templates-work-page-tsx": () => import("./../../../src/templates/work-page.tsx" /* webpackChunkName: "component---src-templates-work-page-tsx" */)
}

